import React from 'react'
import { Link } from 'react-router-dom'

interface ActionButtonsProp {
    size?: string;
}

const ActionButtons = ({ size }: ActionButtonsProp) => {
    return (
        <div className='flex flex-col xs:flex-row md:flex-row items-center gap-4'>
            <a className={`bg-[#090909] ${size == 'small' ? "w-32 h-10 py-2.5 px-2" : "w-40 h-14 py-2.5 px-3"} rounded-xl flex items-center justify-center cursor-pointer`} id='google_playstore' href='https://play.google.com/store/apps/details?id=com.afripay.afripay'>
                <div className='flex items-center'>
                    <img src="/images/google_play.png" alt="Play Store" width={size == "small" ? 24 : 40} />
                    <div className='flex flex-col text-white'>
                        <h3 className={`${size == "small" ? "text-[9px]" : "text-[10px]"} font-light text-nowrap`}>GET IT ON</h3>
                        <p className={`${size == "small" ? "text-[10px]" : "text-sm"} font-semibold text-nowrap`}>Google Play</p>
                    </div>
                </div>
            </a>
            <a className={`bg-[#090909] ${size == 'small' ? "w-32 h-10 py-2.5 pr-2" : "w-40 h-14 py-2.5 pr-3"} rounded-xl flex items-center justify-center cursor-pointer`} id='apple_store' href='https://apps.apple.com/us/app/afripay-app/id6757638682'>
                <div className='flex items-center'>
                    <img src="/images/apple.png" alt="Play Store" width={size == "small" ? 24 : 47} />
                    <div className='flex flex-col text-white'>
                        <h3 className={`${size == "small" ? "text-[9px]" : "text-[10px]"} font-light text-nowrap`}>{size == "small" ? "Download on" : "Download on the"}</h3>
                        <p className={`${size == "small" ? "text-xs" : "text-sm"} font-semibold text-nowrap`}>App Store</p>
                    </div>
                </div>
            </a>
        </div>
    )
}

export default ActionButtons